import * as React from "react";

const SwapIcon = ({
  width = 20,
  height = 19,
  stroke = "#414651",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 19"
    fill="none"
  >
    <path
      d="M8.33326 10.3333C8.69113 10.8118 9.14772 11.2077 9.67205 11.4941C10.1964 11.7806 10.7762 11.9509 11.3721 11.9936C11.9681 12.0363 12.5662 11.9503 13.126 11.7415C13.6858 11.5327 14.1942 11.2059 14.6166 10.7833L17.1166 8.28334C17.8756 7.4975 18.2956 6.44499 18.2861 5.35251C18.2766 4.26002 17.8384 3.21497 17.0658 2.44243C16.2933 1.6699 15.2482 1.2317 14.1558 1.2222C13.0633 1.21271 12.0108 1.63269 11.2249 2.39168L9.79159 3.81668M11.6666 8.66668C11.3087 8.18824 10.8521 7.79236 10.3278 7.50589C9.80347 7.21943 9.22367 7.04908 8.62771 7.0064C8.03176 6.96372 7.4336 7.04971 6.8738 7.25853C6.314 7.46735 5.80566 7.79412 5.38326 8.21668L2.88326 10.7167C2.12426 11.5025 1.70429 12.555 1.71378 13.6475C1.72327 14.74 2.16148 15.7851 2.93401 16.5576C3.70655 17.3301 4.7516 17.7683 5.84408 17.7778C6.93657 17.7873 7.98908 17.3673 8.77492 16.6083L10.1999 15.1833"
      stroke={stroke}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SwapIcon;